import { render, staticRenderFns } from "./ImportJSON.vue?vue&type=template&id=be9941c8"
import script from "./ImportJSON.vue?vue&type=script&lang=js"
export * from "./ImportJSON.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports